import { Component, Input } from '@angular/core';
import { FuStatus } from '@models/system-status';
import { SystemStatusService } from '@service/system-status.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-fu-status-indicator',
    templateUrl: './fu-status-indicator.component.html',
    styleUrls: ['./fu-status-indicator.component.scss'],
    standalone: false,
})
export class FuStatusIndicatorComponent {
    @Input() isReceivingData: boolean;
    @Input() index: number;
    @Input() fuStatus: FuStatus;

    constructor(private systemStatusService: SystemStatusService) {}

    hasAlarms(): boolean {
        if (!this.isReceivingData) return false;
        const fuStatusWithoutSlots = _.omit(this.fuStatus, 'slots');
        return this.systemStatusService.getAlarmCounts(fuStatusWithoutSlots) > 0;
    }

    getIcon(alarmValue: 0 | 1): string {
        if (!this.isReceivingData) return '';
        if (alarmValue === 0) {
            return 'status-error';
        } else if (alarmValue === 1) {
            return 'status-check';
        }
    }
}
